<template>
  <div class="formAuther-container">
    <FormItem
      class="form-item"
      v-for="(v, i) in formValidate.articleAuthorList"
      :key="i"
      label="作者"
      :prop="'articleAuthorList.' + i + '.authorName'"
      :rules="{ required: true, message: '请添加作者', trigger: 'blur' }"
    >
      <Select v-model="v.authorType" style="width: 100px">
        <Option :value="0">学者</Option>
        <Option :value="1">其他</Option>
      </Select>
      <div style="margin: 0 5px; flex: 1" v-if="v.authorType === 0">
        <!-- <MAuthorBox
          :authorObj="v"
          :autherListIndex="i"
          @modifyInfo="
            (query) => {
              modifyInfo(i, query);
            }
          "
        /> -->
        <Input placeholder="请输入作者" v-model.trim="v.authorName" />
      </div>
      <div style="margin: 0 5px; flex: 1" v-else>
        <Input placeholder="请输入作者" v-model.trim="v.authorName" />
      </div>
      <div
        class="plus"
        @click="addAuther(v.authorName)"
        v-if="formValidate.articleAuthorList.length - 1 === i"
      >
        +
      </div>
    </FormItem>
    <FormItem
      class="form-item"
      v-for="(item, index) in formValidate.translator"
      :key="index"
      label="译者"
    >
      <Input v-model="formValidate.translator[index]" placeholder="请输入译者" />
      <div
        class="plus"
        @click="addtranslator(item)"
        v-if="formValidate.translator.length - 1 === index"
      >
        +
      </div>
    </FormItem>
  </div>
</template>

<script>
// import MAuthorBox from "./MAuthorBox.vue";
export default {
  // components: { MAuthorBox },
  props: {
    formValidate: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      firstAutherList: [], //作者列表
    };
  },
  methods: {
    modifyInfo(index, query) {
      this.formValidate.articleAuthorList[index].authorName = query.authorName;
      this.formValidate.articleAuthorList[index].authorId = query.authorId;
      this.formValidate.articleAuthorList[index].authorUnit = query.authorUnit;
      this.formValidate.articleAuthorList[index].authorUnitId =
        query.authorUnitId;
    },
    // 添加其他作者
    addAuther(name) {
      if (name === "") return;
      this.formValidate.articleAuthorList.push({
        authorName: "",
        authorId: null,
        authorUnit: null,
        authorUnitId: null,
        authorType: 0,
      });
    },
    addtranslator(query) {
      console.log(query);
      if (query === "") return;
      this.formValidate.translator.push('');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  opacity: 0.7;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.form-item {
  padding-bottom: 25px;
  width: 100%;
  color: #999;
  border-bottom: 1px solid #dcdcdc;
  &::v-deep .ivu-form-item-label {
    min-width: 80px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  &::v-deep .ivu-form-item-content {
    display: flex;
    align-items: center;
  }
  .plus {
    margin-left: 10px;
    padding: 0 6px;
    width: 30px;
    height: 30px;
    border: 1px solid #dcdcdc;
    border-radius: 50%;
    line-height: 25px;
    font-size: 24px;
    cursor: pointer;
  }
  .icon-pager {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      display: inline-block;
      width: 50px;
      text-align: center;
      user-select: none;
      cursor: pointer;
      color: #999;
      &:active {
        color: #dcdcdc;
      }
    }
  }
  .select-item,
  .none {
    display: flex;
    justify-content: space-around;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background-color: rgb(212, 209, 209);
    }
    span {
      display: inline-block;
      width: 130px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .select-list {
    position: absolute;
    left: 0;
    top: 88px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #dcdcdc;
    z-index: 1;
  }
  .title {
    width: 900px;
    height: 38px;
    line-height: 38px;
    position: relative;
    ::v-deep input {
      font-size: 36px;
    }
    .right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .xing {
    width: 30px;
    color: red;
    text-align: center;
  }
  .left,
  .right {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .left {
    border-right: 1px solid #dcdcdc;
    width: 355px;
  }
  .right {
    margin-left: 10px;
    width: 642px;
  }
  .year,
  .center,
  .stage {
    display: flex;
    align-items: center;
  }
  .year {
    width: 299px;
    border-right: 1px solid #dcdcdc;
  }
  .center {
    width: 323px;
    border-right: 1px solid #dcdcdc;
  }
  .stage {
    width: 374px;
  }
  .checkbox {
    width: 970px;
    display: flex;
    padding-left: 7px;
    label {
      margin-right: 20px;
    }
  }
  .upload {
    display: flex;
    padding-left: 7px;
    align-items: center;
    label {
      margin-right: 20px;
    }
  }
}
</style>
